export default {
	tabs: {
		notDefined: 'غبر معرف',
		journal: 'يوميات المواد',
		invoice: 'اليوميات المرتبطة بالفواتير',
		reconciliation: 'اليوميات المرتبطة بمطابقة المواد',
		all: 'الكل'
	}
}